module.exports = __webpack_public_path__ + "img/compact.733181de.jpg";